import { EventEmitter } from '@angular/core';
import { CommonService } from '../common.service';
import { ApiService } from '../api.service';
var AppGuideComponent = (function () {
    function AppGuideComponent(commonService, apiService) {
        this.commonService = commonService;
        this.apiService = apiService;
        this.outPutMenuClick = new EventEmitter();
        this.outPutToolsClick = new EventEmitter();
        this.isShowItem = false;
        this.isScorm = false; //从LMS平台隐藏引导
        this.rem = 50;
    }
    AppGuideComponent.prototype.ngOnInit = function () {
        this.step = 0;
    };
    AppGuideComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this.pageLoaded) {
            setTimeout(function () {
                _this.haveExerciseBook = !!localStorage.getItem('haveExerciseBook');
                _this.isShowItem = true;
            }, 1000);
        }
        if (localStorage.getItem("source_env") === "LMS_SCORM") {
            this.isScorm = true;
        }
    };
    //设置工具icon引导位置，根据工具栏的tab高度来设置
    AppGuideComponent.prototype.setToolIconTop = function () {
        var toolEle = document.getElementById('app-tools');
        var tootlEleTop = toolEle ? toolEle.getBoundingClientRect().top / this.rem : 0;
        var guideEle = document.getElementById('guide_tools' + this.step);
        guideEle.style.top = tootlEleTop + 'rem';
        console.log('tootlEleTop', tootlEleTop);
        var guide_hand_text = document.getElementById('guide_hand_text');
        guide_hand_text.style.top = ((tootlEleTop + 0.5) + 'rem');
    };
    /**
     * 点击menu
     */
    AppGuideComponent.prototype.clickMenu = function () {
        var that = this;
        that.step = 1;
        that.outPutMenuClick.emit();
        setTimeout(function () {
            that.setToolIconTop();
        }, 100);
    };
    /**
     * 进入工具
     */
    AppGuideComponent.prototype.goTools = function () {
        var _this = this;
        this.commonService.setOnceIno(99999).subscribe(function () {
            _this.outPutToolsClick.emit();
        });
    };
    /**
     *校验用户是否有小工具权限
     */
    AppGuideComponent.prototype.getUserHaveTools = function () {
        return this.apiService.ajax({
            'type': 'GET',
            'url': '/sr/tools/yyToolsLibrary/haveToolsAuthority'
        }).toPromise();
    };
    return AppGuideComponent;
}());
export { AppGuideComponent };



// WEBPACK FOOTER //
// ./src/app/app-guide/app-guide.component.ts.pre-build-optimizer.js